
export { InterceptedHttp } from './http.interceptor';
